import { render, staticRenderFns } from "./fenXi.vue?vue&type=template&id=f1d4628a&scoped=true&"
import script from "./fenXi.vue?vue&type=script&lang=js&"
export * from "./fenXi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d4628a",
  null
  
)

export default component.exports